import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import moment from 'moment'

import AccessModel from '@/core/models/AccessModel'
import ApiRequest from '@/core/ApiRequest'
import { GET_API_REQUEST, GET_ACCESS_MODEL } from '@/store/root/getters'
import { FETCH_CLIENT } from '@/store/root/actions'

import EventsList from '@/components/shared/events-list/EventsList.vue'
import CallsList from '@/components/shared/calls-list/CallsList.vue'

@Component({
  components: { EventsList, CallsList }
})
export default class ClientEvents extends Vue {
  public events: Array<any> = []
  public calls: Array<any> = []
  public name: string = ''
  public phone: string = ''

  /**
   * Get api request object, based on global Vuex state.
   */
  @Getter(GET_API_REQUEST)
  public getApiRequest: ApiRequest

  /**
   * Get access model, based on global Vuex state.
   */
  @Getter(GET_ACCESS_MODEL)
  public getAccessModel: AccessModel | null

  /**
   * Fetch client.
   */
  @Action(FETCH_CLIENT)
  public fetchClient: (id: string) => Object | null


  public addNewEvent () {
    this.$router.push({
      name: 'addEvent',
      query: { date: moment().format('YYYY-MM-DD') }
    })
  }

  public addNewCall () {
    const thisDayDate = new Date(this.$route.params.date)
    this.$router.push({
      name: 'addCall',
      query: { date: moment().format('YYYY-MM-DD') }
    })
  }

  /**
   * Created lifecycle hook. Fires when component instance is created.
   */
  public async created () {
    const client = await this.fetchClient(this.$route.params.id)
    if (!client) {
      this.events = []
      return
    }

    this.name = (client as any).name
    this.phone = (client as any).phone

    const responseCall = await this.getApiRequest.send(
      'GET',
      'clients/' + encodeURIComponent((client as any).id) + '/calls'
    )
    this.calls = []
    if (responseCall && responseCall.data) {
      this.calls = responseCall.data
    }

    const responseEvents = await this.getApiRequest.send(
      'GET',
      'clients/' + encodeURIComponent((client as any).id) + '/events'
    )
    this.events = []
    if (responseEvents && responseEvents.data) {
      this.events = responseEvents.data
    }
  }
}
